module.exports = __webpack_public_path__ + "static/img/logo-jolly88.2fd6e753.png";